import { z } from "zod";
import { BackendErrors } from "../../enums/backendErrors";

const errorDataPayloadSchema = z.object({
  code: z.nativeEnum(BackendErrors),
  reason: z.string(),
});

export const errorIstioSchema = z.object({
  code: z.number(),
  message: z.string(),
  time: z.string(),
});

const errorDefaultResponseSchema = z.object({
  status: z.string(),
  error: z.string(),
});

export const errorDataResponseSchema = z.object({
  status: z.number(),
  data: errorDataPayloadSchema.or(errorIstioSchema),
});

export const errorResponseSchema = errorDefaultResponseSchema.or(errorDataResponseSchema);

export type ErrorDataPayload = z.infer<typeof errorDataPayloadSchema>;
export type ErrorDataResponse = z.infer<typeof errorDataResponseSchema>;
